import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef, useState } from "react";
import stl from "./TextSearchComponent.module.css";
import SearchSVG from "../../../../../../components/UiKit/UiKitSVGs/SearchSVG";
var TextSearchComponent = function TextSearchComponent(_ref) {
  var data = _ref.data,
    onChange = _ref.onChange,
    value = _ref.value,
    disabled = _ref.disabled,
    getData = _ref.getData,
    error = _ref.error,
    className = _ref.className,
    errorMsg = _ref.errorMsg,
    label = _ref.label,
    minLengthForSearch = _ref.minLengthForSearch,
    disableBlur = _ref.disableBlur,
    makeIdValue = _ref.makeIdValue,
    isShowError = _ref.isShowError;
  var UlRef = useRef();
  var _useState = useState(""),
    searchedText = _useState[0],
    setSearchedText = _useState[1];
  var _useState2 = useState(false),
    showErr = _useState2[0],
    setShowErr = _useState2[1];
  var _useState3 = useState(false),
    stopBlur = _useState3[0],
    setStopBlur = _useState3[1];
  useEffect(function () {
    setSearchedText("");
  }, [makeIdValue]);
  var _useState4 = useState("#B7C0C9"),
    iconColor = _useState4[0],
    setIconColor = _useState4[1];
  var combineTextSearch = function combineTextSearch(item, searchedTextF, idx) {
    if ((searchedTextF === null || searchedTextF === void 0 ? void 0 : searchedTextF.trim()) != "" && (data === null || data === void 0 ? void 0 : data.length) > 0) {
      var showText = item.name;
      if (searchedTextF.trim().length && searchedTextF.trim().length >= 1) {
        var startIndex = showText.indexOf(searchedTextF.trim()) != -1 ? showText.indexOf(searchedTextF.trim()) : showText.indexOf(searchedTextF.trim().split(" ")[0]);
        var endIndex = showText.indexOf(searchedTextF.trim()) != -1 ? searchedTextF.trim().length : searchedTextF.trim().split(" ")[0].length;
        var myWord = showText.substr(startIndex, endIndex);
        var finalArrText = [];
        var re = new RegExp(myWord.trim(), "g");
        showText = showText.replace(re, "<span style='font-weight: bold;' class='" + stl.boldWrtnText + "'>" + myWord.trim() + "</span>");
        finalArrText.push(showText);
        return /*#__PURE__*/React.createElement("li", {
          role: "option",
          "aria-selected": item.name === searchedText,
          tabIndex: 0,
          onClick: function onClick() {
            setSearchedText(item.name);
            getData(item);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              setSearchedText(item.name);
              getData(item);
            }
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: stl.wordBuilder
        }, (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/React.createElement("div", {
          className: stl.imageContainerS
        }, /*#__PURE__*/React.createElement("img", {
          src: item === null || item === void 0 ? void 0 : item.image,
          alt: "Search result icon"
        })), /*#__PURE__*/React.createElement("span", {
          style: {
            dir: "rtl"
          },
          className: "",
          dangerouslySetInnerHTML: {
            __html: finalArrText
          }
        })));
      }
    }
  };
  var HandleOnBlur = function HandleOnBlur(e) {
    setIconColor("#B7C0C9");
    if (!e.target.value) {
      getData({
        key: "",
        name: "",
        img: ""
      });
    }
    if (disableBlur) return;
    if (!searchedText.trim() == "") {
      if (UlRef.current.querySelector("li") != undefined) {
        if (!stopBlur) {
          UlRef.current.querySelector("li").click();
        }
      } else {
        setShowErr(true);
      }
      setStopBlur(false);
    }
  };
  useEffect(function () {
    value && setSearchedText(value);
  }, []);
  useEffect(function () {
    value == "" && setSearchedText("");
  }, [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.container, " ").concat(className ? className : "", " ").concat(showErr ? stl.mb40 : "", " ").concat(showErr ? stl.hasError : "")
  }, /*#__PURE__*/React.createElement("input", {
    placeholder: ".",
    onFocus: function onFocus() {
      setShowErr(false);
      setIconColor("#154F9C");
    },
    disabled: disabled,
    type: "text",
    value: searchedText,
    onChange: function onChange(e) {
      setSearchedText(e.target.value);
      // if (cityIdValue === "") {
      //   getData({ key: "", name: "", img: "" });
      // }
    },
    onBlur: function onBlur(e) {
      HandleOnBlur(e);
    },
    onKeyDown: function onKeyDown(e) {
      (e.key === "Enter" || e.keyCode === 13) && e.target.blur();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.iconContainer
  }, /*#__PURE__*/React.createElement(SearchSVG, {
    filledColor: iconColor
  })), /*#__PURE__*/React.createElement("ul", {
    role: "listbox",
    onMouseOver: function onMouseOver() {
      setStopBlur(true);
    },
    onFocus: function onFocus() {
      setStopBlur(true);
    },
    onMouseLeave: function onMouseLeave() {
      setStopBlur(false);
    },
    onBlur: function onBlur() {
      setStopBlur(false);
    },
    ref: UlRef,
    className: [stl.listitems, minLengthForSearch <= (searchedText === null || searchedText === void 0 ? void 0 : searchedText.length) ? undefined : stl.opac0].join(" ")
  }, // minLengthForSearch <= searchedText?.length &&
  data === null || data === void 0 ? void 0 : data.map(function (obj, idx) {
    return obj.name.indexOf(searchedText.trim()) > -1 ? searchedText == "" ? /*#__PURE__*/React.createElement("li", {
      key: "search" + idx,
      role: "option",
      "aria-selected": obj.name === searchedText,
      tabIndex: 0,
      onClick: function onClick() {
        setSearchedText(obj.name);
        getData(obj);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          setSearchedText(obj.name);
          getData(obj);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.wordBuilder
    }, (obj === null || obj === void 0 ? void 0 : obj.image) && /*#__PURE__*/React.createElement("div", {
      className: stl.imageContainerS
    }, " ", /*#__PURE__*/React.createElement("img", {
      src: obj === null || obj === void 0 ? void 0 : obj.image,
      alt: "Search result icon"
    })), /*#__PURE__*/React.createElement("span", {
      className: ""
    }, obj.name))) : /*#__PURE__*/React.createElement(React.Fragment, {
      key: "search" + idx
    }, combineTextSearch(obj, searchedText, idx)) :
    /*#__PURE__*/
    //   <div>{obj.name}</div>
    React.createElement(React.Fragment, {
      key: "search" + idx
    });
  })), (isShowError || showErr) && /*#__PURE__*/React.createElement("p", {
    className: " ".concat(stl.error)
  }, errorMsg), /*#__PURE__*/React.createElement("label", {
    className: stl.label
  }, label)));
};
export default TextSearchComponent;